import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import {
  dateSchema,
  parseToDateValue,
  preprocessTextAsyncAutocompleteField,
} from "@/features/FormCard/utils";
import { z } from "zod";

const filterE3DataUploadSchema = z.object({
  file_name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  provider_config_name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  created_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  created_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export const ConfigSchema = z.object({
  id: z.number(),
  code: z.string(),
  file_pattern: z.string().optional(),
  client: z.string().optional(),
  mime_type: z.string().optional(),
  template_file_id: z.number().optional(),
  template_file_name: z.string().optional(),
});

export const UploadSchema = z.object({
  config_name: z.string().min(1, "La configuration est requise"),
  files: z
    .array(z.instanceof(File))
    .nonempty("Vous devez ajouter au moins un fichier"),
});

export type UploadSchemaType = z.infer<typeof UploadSchema>;
export type ConfigSchemaType = z.infer<typeof ConfigSchema>;

export type FilterE3DataUploadSchema = z.infer<typeof filterE3DataUploadSchema>;

const fields: Field[] = [
  {
    name: "file_name_contains",
    label: `Nom du fichier`,
    type: "asyncAutocomplete",
    base_url: "e3/e3_data_upload",
    column_name: "file_file_name",
  },
  {
    name: "provider_config_name_contains",
    label: "Configuration name",
    type: "asyncAutocomplete",
    base_url: "e3/e3_data_upload",
    column_name: "provider_config_name",
  },
  {
    name: "created_at",
    type: "dateRange",
    label: "Date de création",
    from: { name: "created_at_from" },
    to: { name: "created_at_to" },
    col_span: 2,
  },
];

const client = "e3";

export function E3DataUploadFilter() {
  return (
    <FilterTable
      client={client}
      schema={filterE3DataUploadSchema}
      tableName="e3_data_upload"
      fields={fields}
    />
  );
}
